import React from 'react';
export function GuaranteeBadge() {
  return <section className="w-full bg-pinkLight px-5 py-10 md:py-16" data-id="element-107">
      <div className="mx-auto max-w-[480px]" data-id="element-108">
        <div className="rounded-[12px] bg-white p-5 text-center md:p-6" data-id="element-109">
          <div className="text-[32px]" aria-hidden="true" data-id="element-110">
            🛡️
          </div>
          <p className="label-caps mt-2 text-[12px] text-rose" data-id="element-111">
            Garantía de 7 días
          </p>
          <p className="mt-3 text-[13px] text-wine" style={{
          lineHeight: 1.6
        }} data-id="element-112">
            Si en una semana sientes que la guía no es para ti, escríbeme y te
            devuelvo cada dólar. Sin preguntas, sin formularios raros. Tu
            confianza vale más que una venta.
          </p>
        </div>
      </div>
    </section>;
}